import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAuth, IUser } from '@core/models';
import { clearLocalStorage, setTokenLocalStorage, setUserLocalStorage } from '@core/services';
import { AppState } from '@store/store';
import { getFirstName, getInitials } from '@core/utils';

interface ILoginState {
    auth: IAuth;
    loading: boolean;
    error: string | null;
}

const initialState: ILoginState = {
    auth: {
        token: '',
        user: null
    },
    loading: false,
    error: null
};

export const loginSlice = createSlice({
    name: 'login',
    initialState,
    reducers: {
        login_fetching: (state) => {
            state.loading = true;
            state.auth.token = '';
            state.error = null;
        },
        current_fetching: (state) => {
            state.auth.user = null;
        },
        login_success: (state, action) => {
            const { token } = action.payload;
            state.error = null;
            state.auth.token = token;
            setTokenLocalStorage(token);
        },
        current_success: (state, action: PayloadAction<IUser>) => {
            state.auth.user = {
                ...action.payload,
                initials: getInitials(action.payload.nome),
                primeiroNome: getFirstName(action.payload)
            };
            state.loading = false;
            setUserLocalStorage(action.payload);
        },
        login_error: (state, action: PayloadAction<string>) => {
            state.error = action.payload;
            state.loading = false;
            state.auth.token = '';
        },
        current_error: (state, action: PayloadAction<string>) => {
            state.error = action.payload;
            state.loading = false;
            state.auth.token = '';
        },
        logout: (state) => {
            state.error = '';
            state.loading = false;
            state.auth.token = '';
            clearLocalStorage();
        }
    }
});

export const { login_fetching, login_error, login_success, current_fetching, current_error, current_success, logout } = loginSlice.actions;

export const selectorAuth = (state: AppState) => state.auth;

export default loginSlice.reducer;
